/**
 * HomeRouter — root path dispatcher.
 *
 * Reads two signals to swap the homepage per site:
 *   1. Domain — indianfamilytree.com auto-routes to its own home page
 *   2. `?site=<slug>` query — preview any child home from inside the parent
 *
 * Use cases:
 *   /                        → default Home (or the domain-matched sibling home)
 *   /?site=kerala            → KeralaHome
 *   /?site=indianfamilytree  → IndianFamilyTreeHome
 *   /?site=socialpulse       → default Home (explicit opt-in)
 */
import { useSearchParams } from "react-router-dom";
import FoodPulseHomeV3 from "@/pages/FoodPulseHomeV3";
import KeralaHome from "@/pages/KeralaHome";
import KeralaTravelsHome from "@/pages/KeralaTravelsHome";
import IndianFamilyTreeHome from "@/pages/IndianFamilyTreeHome";
import MyFamilyTreeCareHome from "@/pages/MyFamilyTreeCareHome";
import { resolveSiteSlug } from "@/config/siteConfig";

const SITE_ROUTES = {
  kerala:            KeralaHome,
  keralatravels:     KeralaTravelsHome,
  indianfamilytree:  IndianFamilyTreeHome,
  myfamilytreecare:  MyFamilyTreeCareHome,
  foodpulse:         FoodPulseHomeV3,
};

export default function HomeRouter() {
  const [params] = useSearchParams();
  const queryParam = (params.get("site") || "").toLowerCase();
  // Query param wins for previewing inside the parent. Otherwise fall
  // through to hostname-based resolution so indianfamilytree.com just
  // works on its apex domain.
  const site = queryParam || resolveSiteSlug();
  // Default to FoodPulse V3 on all unrecognised / SocialPulse slugs.
  const Component = SITE_ROUTES[site] || FoodPulseHomeV3;
  return <Component />;
}
